import { useEffect } from "react";

export default function TokenLoginPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("tkn");

    if (token) {
      localStorage.setItem("aghighToken", token);
    }

    // رفتن به صفحه اصلی با رفرش کامل
    window.location.replace("/");
  }, []);

  // صفحه بدون محتوا
  return <div style={{ display: "none" }}>در حال ورود...</div>;
}